import TemplateView from "../../TemplateView"
import CommentInputContainer from './CommentInputContainer'

export default class CommentsFooter extends TemplateView {
    constructor({
        onCommentTextChange = () => {},
        onShowInputChanged = () => {},
        onCommentAdded = () => {},
        refreshScrollCb = () => {},
    }) {
        super();

        this.callbacks = {
            onCommentTextChange,
            onShowInputChanged,
            onCommentAdded,
            refreshScrollCb,
        }

        this.state = {
            loggedInUser: null,
            sending: false,
            showNewCommentInput: false,
            commentText: '',
        }

        this.onStatePropertyChanged('loggedInUser', () => this._renderCommentInput())
        this.onStatePropertyChanged('sending', sending => this.commentInput.setState({sending}))
        this.onStatePropertyChanged('showNewCommentInput', showCommentInput => this.commentInput.setState({showCommentInput}))
        this.onStatePropertyChanged('commentText', commentText => this.commentInput.setState({commentText}))
    }

    templateHtml() {
        return "<div class='commentsFooter'>" +
               "    <div class='commentInputPlaceholder'/>" +
               "</div>"
    }

    afterRender() {
        this.$commentInput = this.find('.commentInputPlaceholder')
    }

    _renderCommentInput() {
        this.$commentInput.empty()
        this.commentInput = new CommentInputContainer({
            userInfo: this.state.loggedInUser,
            onCommentTextChange: this.callbacks.onCommentTextChange,
            onShowInputChanged: this.callbacks.onShowInputChanged,
            onCommentAdded: this.callbacks.onCommentAdded,
            refreshScrollCb: this.callbacks.refreshScrollCb,
        }).init(this.$commentInput)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentsFooter.js